import BaseModelAPI from '../BaseModelAPI';

export default class BranchList extends BaseModelAPI {

	static entity = 'branchlist'
	static entityName = 'branch';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
